import header from '../modules/header';
import hero from '../modules/slider/hero';
import ageSelector from '../modules/slider/age-selector';
import hamburger from '../modules/hamburger'; 
import recentPosts from '../modules/slider/recent-posts';
import video from '../modules/video/video';
import storeLocator from '../modules/storeLocator';
import productSlider from '../blocks/productSlider';
import filters from '../modules/filters';
import menu from '../modules/menu';

export default {
    init(){
        // Javascript to be fired on all pages
    },
    finalize(){
        header();
        hero();
        ageSelector();
        recentPosts();
        video();
        storeLocator();
        productSlider();
        filters();
        menu();

        // Hamburger
        let allHtml = document.querySelector('html'); 
        hamburger.register('body',{
            onOpen: () => {
            allHtml.style.overflowY = 'hidden';
            },
            onClose: () => {
            allHtml.style.overflowY = 'auto';
            document.body.classList.remove('is-mobile-products-open'); 
            document.body.classList.remove('is-mobile-product-category-open');
            const mobile_items_panel_second = document.querySelectorAll('.js-mobile-panel-second');
            if (mobile_items_panel_second) {            
                mobile_items_panel_second.forEach(element => {
                element.classList.remove('is-active');
                });
            }
            },
        });
    },
}